import template from './notfound.html';
import './notfound.styl';

const notfoundComponent = {
  template
};

export default notfoundComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/errors/notfound/notfound.component.js
 **/